import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconCircleXProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconCircleX: React.FC<IconCircleXProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Reject',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="m15 9-6 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="m9 9 6 6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconCircleX;
